import React from 'react';
import styles from './HotkeysList.module.scss';
import { inject } from 'mobx-react';
import { EDITOR_HOTKEYS_STORE } from 'store';
import { HotkeysListProps } from './types';
import HotkeyDetails from './HotkeyDetails';
import { ScrollableContainer } from 'components/common';

const HotkeysList = (props: HotkeysListProps) => {
  const {
    [EDITOR_HOTKEYS_STORE]: { hotkeys }
  } = props;

  return (
    <ScrollableContainer className={styles.container}>
      {hotkeys().map((hotkey, index) => <HotkeyDetails key={index} {...hotkey} />)}
    </ScrollableContainer>
  );
};

export default inject(EDITOR_HOTKEYS_STORE)(HotkeysList);
